module.exports = __webpack_public_path__ + "cover_background.1feedc028867a5e2bd3695207db033f4.png";